import { gql } from '@apollo/client';
 
const BOOK_FIELDS = `
  id
  title
  subtitle
  authors
  description
  coverUrl
  publishedYear
  pageCount
  genres
  shelf
  collection
  format
  favorite
  rating
  review
  notes
  progressType
  currentPage
  currentPercent
  currentMinutes
  startedDate
  finishedDate
  lastReadDate
  updatedAt
`;

const BOOK_LIST_FIELDS = `
  id
  title
  subtitle
  authors
  coverUrl
  publishedYear
  pageCount
  genres
  shelf
  collection
  format
  favorite
  rating
  progressType
  currentPage
  currentPercent
  currentMinutes
  lastReadDate
  updatedAt
`;

export const GET_BOOKS = gql`
  query GetBooks($first: Int, $after: String) {
    getBooksListPage(first: $first, after: $after) {
      nodes {
        ${BOOK_LIST_FIELDS}
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`;

export const GET_BOOK = gql`
  query GetBook($id: ID!) {
    getBook(id: $id) {
      ${BOOK_FIELDS}
    }
  }
`;

export const SEARCH_BOOKS = gql`
  query SearchBooks($query: String!) {
    searchBooks(query: $query) {
      catalogId
      title
      subtitle
      authors
      description
      coverUrl
      publishedYear
      pageCount
      genres
    }
  }
`;

export const ADD_BOOK = gql`
  mutation AddBook($input: BookInput!) {
    addBook(input: $input) {
      ${BOOK_FIELDS}
    }
  }
`;

export const UPDATE_BOOK = gql`
  mutation UpdateBook($id: ID!, $input: BookInput!) {
    updateBook(id: $id, input: $input) {
      ${BOOK_FIELDS}
    }
  }
`;

export const DELETE_BOOK = gql`
  mutation DeleteBook($id: ID!) {
    deleteBook(id: $id)
  }
`;

export const UPDATE_BOOK_PROGRESS = gql`
  mutation UpdateBookProgress($id: ID!, $input: BookProgressInput!) {
    updateBookProgress(id: $id, input: $input) {
      ${BOOK_FIELDS}
    }
  }
`;

const GOODREADS_CANDIDATE_FIELDS = `
  title
  subtitle
  authors
  description
  coverUrl
  publishedYear
  pageCount
  genres
  shelf
  collection
  format
  favorite
  rating
  review
  notes
  progressType
  currentPage
  currentPercent
  currentMinutes
  startedDate
  finishedDate
  lastReadDate
`;

export const PREVIEW_GOODREADS_IMPORT = gql`
  mutation PreviewGoodreadsImport($input: GoodreadsImportPreviewInput!) {
    previewGoodreadsImport(input: $input) {
      totalRows
      importableCount
      duplicateCount
      maxBatchSize
      items {
        rowId
        duplicate
        duplicateReason
        book {
          ${GOODREADS_CANDIDATE_FIELDS}
        }
      }
    }
  }
`;

export const IMPORT_GOODREADS_BOOKS = gql`
  mutation ImportGoodreadsBooks($input: GoodreadsImportInput!) {
    importGoodreadsBooks(input: $input) {
      importedCount
      skippedCount
      failedCount
      books {
        ${BOOK_FIELDS}
      }
      failures {
        rowId
        title
        message
      }
    }
  }
`;
